import { StatusCodes } from '@/data/libraries/Status';
import dateFormat from '@/domain/utils/dateFormat';


/**
 * Hook personalizado para determinar el formato de la fecha de entrega.
 * 
 * @param {string} ordInitialDeliveryDate
 * @param {string} ordFinalDeliveryDate
 * @param {number} status
 * 
 * @returns {string} Objeto que contiene las dimensiones de la pantalla.
 * 
 */
const deliveryDate = (ordInitialDeliveryDate:string, ordFinalDeliveryDate:string, status:number, withLabel:boolean=true): string => {
  
  /** Funciones de formato de fecha*/
  const { formatZonedDateTimeToString } = dateFormat();

  const ESTIMATED_DELIVERY: string = 'Entrega estimada: ';

  let deliveryDateString: string = '';

  if (
    [StatusCodes.ORDER_SENT, StatusCodes.ORDER_PROCESSING, StatusCodes.ORDER_DELIVERED, StatusCodes.ORDER_CANCELED].includes(
      status ?? 0,
    )
  ) {
    if (ordInitialDeliveryDate && ordFinalDeliveryDate) {
      deliveryDateString = withLabel ? `${ESTIMATED_DELIVERY} ` : '';
      if (ordInitialDeliveryDate === ordFinalDeliveryDate) {
        deliveryDateString += formatZonedDateTimeToString(ordInitialDeliveryDate);
      } else {
        deliveryDateString += `${formatZonedDateTimeToString(ordInitialDeliveryDate)} al ${formatZonedDateTimeToString(
          ordFinalDeliveryDate,
        )}`;
      }
      
    }
  }

  return deliveryDateString;
};

export default deliveryDate;